import {Stack, StackProps, Switch, SwitchProps, Typography} from '@mui/material';
import {forwardRef} from 'react';
import {STYLES} from './styles';

interface Props extends SwitchProps {
  label?: string;
  justifyContent?: StackProps['justifyContent'];
  labelColor?: string;
}

export const SwitchField = forwardRef<HTMLInputElement, Props>(({label, justifyContent, labelColor, ...props}, ref) => {
  return (
    <Stack direction="row" gap={2} alignItems="center" justifyContent={justifyContent}>
      {label && (
        <Typography sx={STYLES.title} variant="caption" color={labelColor}>
          {label}
        </Typography>
      )}
      <Stack sx={STYLES.container}>
        <Switch sx={STYLES.switch} inputRef={ref} {...props} />
      </Stack>
    </Stack>
  );
});
